import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useController } from 'react-hook-form';
import { ProviderModels } from '@modules/ai/common/forms/common/provider-models';
import { getAvailableModelConfigurations, getAvailableModelDefinitions, getUnavailableModelConfigurations } from '@modules/ai/common/model-definitions';
export function OpenAiPlatformProviderModels(props) {
    var _a, _b, _c, _d;
    const { form, className, availableProvider } = props;
    const modelConfigurations = getAvailableModelConfigurations((_b = (_a = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _a === void 0 ? void 0 : _a.OPENAI) !== null && _b !== void 0 ? _b : []);
    const unsupportedModelConfigurations = getUnavailableModelConfigurations((_d = (_c = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _c === void 0 ? void 0 : _c.OPENAI) !== null && _d !== void 0 ? _d : []);
    const modelsController = useController({ name: 'provider.openai.models', control: form.control });
    const createNewModel = useCallback((type) => {
        var _a;
        const model = getAvailableModelDefinitions((_a = availableProvider === null || availableProvider === void 0 ? void 0 : availableProvider.models) === null || _a === void 0 ? void 0 : _a.OPENAI)
            .map(md => md.model)
            .find(model => model.id === type);
        if (!model) {
            throw new Error(`Illegal Application state, Model with id ${type} not found`);
        }
        return model;
    }, [availableProvider]);
    return (_jsx(ProviderModels, { createNewModel: createNewModel, columns: colums, modelConfigurations: modelConfigurations, unsupportedModelConfigurations: unsupportedModelConfigurations, className: className, modelsController: modelsController, withHeader: true }));
}
const colums = [
    {
        id: 'id',
        title: 'ID'
    },
    {
        id: 'modelName',
        title: 'Model name'
    }
];
